<!--Start Back To Top Button--> 
	<!-- <a href="#" (click)="$event.preventDefault()" class="back-to-top"><i class='bx bxs-up-arrow-alt'></i></a> -->
<!--End Back To Top Button-->
<!--footer -->
<!-- <footer class="page-footer">
	<p class="mb-0">Copyright © 2022. Gobierno Municipal de Vinto.</p>
</footer> -->
<!-- end footer -->
<footer>
	<div class="bottom-footer">
	  <div class="conatiner">
		<p>© Copyright 2023 Sistemas Informáricos GAMV</p>
	  </div><!-- container -->
	</div><!--bottom-footer-->
</footer>